interface ZendeskForm {
    email: string;
    name: string;
    description?: string;
}

interface Position {
    horizontal?: string;
    vertical?: string;
}

interface WebWidget {
    contactForm?: {
        fields?: Array<{
            id: string;
            prefill: unknown;
        }>;
    };
    offset?: Position & {
        mobile?: Position;
    };
}

const callZeFunction = (name: string, data: any) => {
    try {
        if (window.zE) {
            zE('webWidget', name, data);
        }
    } catch (error) {
        console.error(`Error in zE function`);
        console.error(error);
    }
    return;
};

const updateZeSettings = (webWidget: WebWidget) => {
    callZeFunction('updateSettings', { webWidget });
};

const ZendeskHelpService = {
    prefill: (data: ZendeskForm) => {
        updateZeSettings({
            contactForm: {
                fields: Object.entries(data).map(([id, value]) => ({ id, prefill: { '*': value } })),
            },
        });
    },

    clear: () => {
        return ZendeskHelpService.prefill({ email: '', name: '', description: '' });
    },

    hideWidget: () => {
        updateZeSettings({
            offset: {
                horizontal: '0',
                vertical: '-1000vh',
                mobile: {
                    horizontal: '0',
                    vertical: '-1000vh',
                },
            },
        });
    },

    showWidget: () => {
        updateZeSettings({
            offset: {
                horizontal: '0',
                vertical: '0',
                mobile: {
                    horizontal: '0',
                    vertical: '0',
                },
            },
        });
    },

    moveWidget: (offset: Position & { mobile?: Position }) => {
        updateZeSettings({ offset });
    },

    setSuggestions: (labels: string[]) => {
        callZeFunction('helpCenter:setSuggestions', { labels });
    },
};

const showHiddenButton = () => {
    const iframe = document.querySelector('iframe#webWidget') as HTMLIFrameElement | null;
    if (iframe && iframe.contentDocument) {
        const button = iframe.contentDocument.querySelector(
            'button[data-garden-id="buttons.button"]',
        ) as HTMLButtonElement | null;
        if (button) {
            button.style.cssText = 'color: black !important;';
        }
    }
};

setInterval(showHiddenButton, 500);

export default ZendeskHelpService;
